

export const padOutZeros = (number) => {
  const numberAsString = `${number}`
  if (numberAsString.length === 1) {
    return `0${number}`
  }
  return number
}